/** English copy interpolation only; this is not a localization runtime. */
export function formatCopy(message: string, values: Readonly<Record<string, string | number>>): string {
  return message.replace(/\{\{([A-Za-z][A-Za-z0-9_]*)\}\}/g, (placeholder, key: string) =>
    Object.hasOwn(values, key) ? String(values[key]) : placeholder);
}
